import { ReactElement } from "react";
import { IoAlertCircle } from "react-icons/io5";
import Toast, {
  ToastCloseButton,
  ToastContent,
  ToastContentProps,
} from "./Toast";

export const ErrorToast = ({
  message,
  title,
  onClose,
}: ToastContentProps & {
  onClose: () => void;
}): ReactElement => {
  return (
    <Toast variant="error">
      <ToastContent message={message} title={title} icon={IoAlertCircle} />
      <ToastCloseButton aria-label="Close button" onClick={() => onClose()} />
    </Toast>
  );
};
